import React, { useState, useRef } from "react";
import { Button } from "react-bootstrap";

import LoadingButton from "../components/LoadingButton";
import ReactCroppie from "../components/ReactCroppie";
import StorageImage from "../components/StorageImage";
import EditContainer from "../components/EditContainer";
import { useUser, storage } from "../firebase";

const croppieOptions = {
  boundary: { height: 200 },
  viewport: { width: 160, height: 160, type: "circle" },
  showZoomer: false
};

const EditProfilePic = ({ location }) => {
  const { user, forceUpdate, refresh } = useUser();
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filename, setFilename] = useState("Choose file...");
  const [src, setSrc] = useState("assets/user-placeholder.jpeg");
  const croppieRef = useRef();

  const handleFileChange = e => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      setFilename(file.name);

      const reader = new FileReader();
      reader.onload = () => {
        setSrc(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSave = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await croppieRef.current.result({
        type: "blob",
        circle: false
      });
      await storage()
        .ref(`profile/${user.uid}.png`)
        .put(res)
        .then();

      forceUpdate();
      setLoading(false);
      setEditing(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      setEditing(false);
    }
  };

  return (
    <EditContainer
      title="Profile Picture"
      addDisabled={editing}
      addIcon="Pencil"
      handleAdd={() => setEditing(true)}
    >
      {editing ? (
        <div>
          <div className="mt-3">
            <ReactCroppie src={src} options={croppieOptions} ref={croppieRef} />
          </div>
          <div>
            <form onSubmit={handleSave}>
              <div className="form-file mb-3">
                <input
                  type="file"
                  id="file"
                  name="file"
                  accept="image/*"
                  className="form-file-input"
                  onChange={handleFileChange}
                />
                <label className="form-file-label" htmlFor="file">
                  <span className="form-file-text">{filename}</span>
                  <span className="form-file-button">Browse</span>
                </label>
              </div>
              <div className="d-flex justify-content-end align-items-center">
                <Button
                  variant="secondary"
                  className="mr-2"
                  onClick={() => setEditing(false)}
                  disabled={loading}
                >
                  Cancel
                </Button>
                <LoadingButton
                  isLoading={loading}
                  variant="primary"
                  type="submit"
                >
                  Update
                </LoadingButton>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center py-3">
          {user && user.uid && (
            <StorageImage
              path={`profile/${user.uid}.png`}
              alt="profile"
              update={refresh}
              className="avatar"
            />
          )}
        </div>
      )}
    </EditContainer>
  );
};

export default EditProfilePic;
